import produce from 'immer';
import { Middleware } from 'redux';
import { EndPoints } from 'src/config';
import { checkApiError } from 'src/handlers';
import { appHeaders } from 'src/helpers/auth';
import { RootState } from 'src/store';
import { ESTORE_SUBMIT_DATA_INFO } from '../../EStore.types';
import {
  setEStoreSubmitDataSetError,
  setEStoreSubmitDataSetLoader,
  setEStoreSubmitDataSetSuccess,
  setResetEStoreFormData,
} from '../EStoreSlicer';

export const EStoreSubmitDataMiddleware: Middleware = (api) => (next) => async (action) => {
  const { type } = action;

  if (type !== ESTORE_SUBMIT_DATA_INFO) {
    next(action);
    return;
  }

  const data = api.getState() as RootState;

  const { sender, receiver, toAgency, colisNumber, description, senderIsNotReceiver } = data.eStore.form;
  const info = data.eStore.agency.info;
  const AgencyInfo = data.eStore.agency.info;

  if (!sender.tel || !sender.firstName || !sender.lastName || !AgencyInfo) {
    return next(setEStoreSubmitDataSetError({ error: new Error('need_params') }));
  }

  try {
    next(setEStoreSubmitDataSetError({ error: null }));
    next(setEStoreSubmitDataSetLoader({ isLoading: true }));
    next(setEStoreSubmitDataSetSuccess({ success: null }));

    const senderWithPhone = produce(sender, (draft) => {
      if (!draft.tel.includes('+')) {
        draft.tel = '+' + draft.tel;
      }
    });

    const receiverWithPhone = produce(receiver, (draft) => {
      if (!draft) return null;
      if (!draft.tel.includes('+')) {
        draft.tel = '+' + draft.tel;
      }
    });

    const payloadData = {
      formData: {
        sender: senderWithPhone,
        receiver: receiverWithPhone,
        toAgencySlug: toAgency,
        colisNumber,
        description,
        senderIsNotReceiver,
        fromAgencySlug: info?.slug,
        internetReferenceCampaign: data.internetCampaign.internetReferenceCampaign,
        internetProviderCampaign: data.internetCampaign.internetProviderCampaign,
        marketingAgencyId: data.eStore.marketingAgencyId,
      },
    };

    const response = await fetch(EndPoints.clientPublicEStoreCreate, {
      headers: appHeaders(),
      method: 'POST',
      body: JSON.stringify(payloadData),
    });

    const json = await response.json();
    checkApiError(json);
    next(setResetEStoreFormData());
    next(setEStoreSubmitDataSetSuccess({ success: 'success_done' }));
  } catch (e) {
    return next(setEStoreSubmitDataSetError({ error: e as Error }));
  } finally {
    next(setEStoreSubmitDataSetLoader({ isLoading: false }));
  }
};
